import type { CSSObject } from "type/tss";

// Q2 2026 integration card: 24px card padding, 24px gap between title row,
// status tag, and the actions row (View Details left, trash bottom-right).
export const styles = () => {
	return ({
		card: {
			display: "flex",
			flexDirection: "column",
			height: "100%",
			padding: 24,
		},
		header: {
			padding: 0,
		},
		content: {
			padding: "24px 0 0",
			"&:last-child": {
				paddingBottom: 0,
			},
		},
		cardActions: {
			flex: 1,
			alignItems: "flex-end",
			justifyContent: "space-between",
			padding: "24px 0 0",
			// "View Details" is a text button; strip its horizontal padding so the
			// label sits flush with the left edge of the card content (MAX-4133).
			"& .MuiButton-text": {
				paddingLeft: 0,
				paddingRight: 0,
			},
		},
		icon: {
			width: 24,
			paddingTop: 2,
		},
	} satisfies Record<string, CSSObject>);
};
